import React, {useCallback} from 'react';

import {SearchPbId} from 'src/components/search-pb-id';
import {ReferenceEntityType} from 'src/openapi/admin/models/ReferenceEntityType';

import type {UserInformation} from 'src/modules/profile/account/create-user/typedef';

type Props = {
    setUserDetails: React.Dispatch<React.SetStateAction<UserInformation>>,
    pbId: string,
    disabled?: boolean,
    onFieldChange: () => void,
};

const PB_IDS: Array<string> = [];

export const UserPBId = ({setUserDetails, pbId, disabled, onFieldChange}: Props) => {
    const onSelect = useCallback((id: string) => {
        onFieldChange();
        setUserDetails(state => ({...state, pbId: id}));
    }, [onFieldChange, setUserDetails]);

    return (
        <SearchPbId
            entityType={ReferenceEntityType.PERSON_TYPE}
            disabled={disabled}
            value={pbId}
            id={0}
            placeholder="PB RTS ID if user has PitchBook Profile"
            pbIds={PB_IDS}
            width={300}
            onSelect={onSelect}
            onRemove={() => onSelect('')}
        />
    );
};
